import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { siteInfo } from "@/mocks/guagua";

const ANCHORS = [
  { label: "热门事件", href: "#hot" },
  { label: "主题分类", href: "#categories" },
  { label: "一周盘点", href: "#weekly" },
  { label: "必看清单", href: "#mustsee" },
  { label: "常见问题", href: "#faq" },
];

const HOT_TAGS = ["群像综艺", "杀青路透", "巡演歌单", "红毯造型", "联名物料"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/collections?q=${encodeURIComponent(q)}` : "/collections");
  };

  return (
    <section className="relative w-full overflow-hidden" aria-label="首屏品牌介绍">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20entertainment%20studio%20backdrop%20with%20coral%20amber%20and%20green%20gradient%20shapes%2C%20soft%20bokeh%20stage%20lights%2C%20minimal%20modern%20editorial%20composition%2C%20cream%20background%2C%20no%20text&width=1800&height=1000&seq=chigua-hero-01&orientation=landscape"
          alt="吃瓜合集导航首屏抽象背景"
          title="吃瓜合集导航 - 一站式吃完全部瓜"
          className="h-full w-full object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45" aria-hidden="true"></div>

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur-sm md:text-sm">
          <i className="ri-sparkling-2-line leading-none" aria-hidden="true"></i>
          每天整理热度榜 · 一周盘点不断更
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-black leading-tight text-white md:text-6xl">
          吃瓜合集导航
          <span className="mt-2 block text-xl font-bold text-white/90 md:mt-3 md:text-3xl">
            {siteInfo.slogan}，热门话题一次看完
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
          把散落在各平台的娱乐话题、一周盘点与必看清单，按热度重新整理成可直接读完的合集，省去在十几个页面之间来回切换的时间。
        </p>

        <form onSubmit={handleSearch} className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row">
          <div className="relative flex-1">
            <i
              className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400 leading-none"
              aria-hidden="true"
            ></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索话题、节目或关键词，如「巡演」"
              aria-label="搜索合集"
              className="h-12 w-full rounded-full border border-transparent bg-white/95 pl-11 pr-4 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-300/60"
            />
          </div>
          <button
            type="submit"
            className="h-12 shrink-0 rounded-full bg-primary-500 px-7 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            搜合集
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-white/70 md:text-sm">大家在搜：</span>
          {HOT_TAGS.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => navigate(`/collections?q=${encodeURIComponent(tag)}`)}
              className="rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs text-white/90 backdrop-blur-sm transition-colors hover:bg-white/20 md:text-sm"
            >
              {tag}
            </button>
          ))}
        </div>

        <nav className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="页面锚点导航">
          {ANCHORS.map((a) => (
            <a
              key={a.href}
              href={a.href}
              className="text-sm font-medium text-white/75 transition-colors hover:text-white"
            >
              {a.label}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
}